//docs list
import { Link } from "react-router-dom";
import VaultInfoCard from "./vault-infocard";

export default function VaultDocsModule(props) {

  const data = props.data;

  if (data && data.length===0)
  return (<><p className="text-muted small">No Records</p> </>)

  return (
    <>
    <div className="">

        {data && data.map((item, i) => (
          
          <div className="col" key={i}>
            <Link to={`/vault/view/${item.enid}`} className="">

              <VaultInfoCard data={item} />

            </Link>
          
          </div>
        ))}
    </div>
    </>
  )
}